/**
 * sofa-ar.js — "View in your room" AR launcher.
 *
 * Loaded ONLY on products with a 3D model in their media (strictly gated in
 * Liquid, like every other configurator feature). No third-party services:
 *  - iOS      → AR Quick Look via Shopify's auto-generated USDZ (rel="ar")
 *  - Android  → Scene Viewer intent with the GLB
 *  - Desktop  → modal with a locally generated QR code (qrcode-generator.js)
 *               pointing the phone at this page with ?room=1, which surfaces
 *               a one-tap launch banner (mobile browsers block un-gestured AR).
 */
(function () {
  'use strict';

  function init() {
    var root = document.querySelector('[data-cfg-ar]');
    if (!root) return;

    // Liquid emits protocol-relative CDN URLs (//…) — Scene Viewer's intent
    // needs a fully qualified https URL, so normalise both up front.
    function absolutise(u) {
      if (!u) return '';
      if (u.indexOf('//') === 0) return 'https:' + u;
      return u;
    }
    var usdz = absolutise(root.dataset.cfgArUsdz);
    var glb = absolutise(root.dataset.cfgArGlb);
    var modal = root.querySelector('[data-cfg-ar-modal]');
    var banner = root.querySelector('[data-cfg-ar-banner]');

    // Android first: its UA is unambiguous, while the iPadOS test
    // (MacIntel + touch) is a heuristic that would otherwise win on a
    // touch-capable Mac and route Android devices to a .usdz.
    var ua = navigator.userAgent;
    var isAndroid = /Android/.test(ua);
    var isIOS = !isAndroid && (/iPhone|iPad|iPod/.test(ua) ||
      (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1));

    function launchAR() {
      if (isIOS && usdz) {
        // Safari requires the rel="ar" anchor to contain an <img> child —
        // the hidden anchor in the Liquid provides exactly that.
        var a = root.querySelector('[data-cfg-ar-quicklook]');
        if (a) { a.click(); return; }
      }
      if (isAndroid && glb) {
        var intent = 'intent://arvr.google.com/scene-viewer/1.0' +
          '?file=' + encodeURIComponent(glb) +
          '&mode=ar_preferred' +
          '&title=' + encodeURIComponent(document.title) +
          '#Intent;scheme=https;package=com.google.android.googlequicksearchbox;' +
          'action=android.intent.action.VIEW;' +
          'S.browser_fallback_url=' + encodeURIComponent(window.location.href) + ';end;';
        window.location.href = intent;
        return;
      }
      openModal(); // not a supported phone → show the QR path
    }

    function qrTargetUrl() {
      // Point the phone at the bare ?view=ar hand-off template, which loads
      // in ~2KB and goes straight into AR — no second tap, no full PDP.
      // ?variant is preserved so "view full details" lands on the same config.
      var url = new URL(window.location.href);
      url.searchParams.delete('room');
      url.searchParams.set('view', 'ar');
      url.hash = '';
      return url.toString();
    }

    function openModal() {
      if (!modal) return;
      var box = modal.querySelector('[data-cfg-ar-qr]');
      if (box && typeof window.qrcode === 'function') {
        var qr = window.qrcode(0, 'M');
        qr.addData(qrTargetUrl());
        qr.make();
        box.innerHTML = qr.createSvgTag({ cellSize: 5, margin: 0, scalable: true });
      }
      modal.hidden = false;
      document.body.classList.add('cfg-ar-modal-open');
    }

    function closeModal() {
      if (!modal) return;
      modal.hidden = true;
      document.body.classList.remove('cfg-ar-modal-open');
    }

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-cfg-ar-launch]')) {
        if (isIOS || isAndroid) launchAR();
        else openModal();
        return;
      }
      if (e.target.closest('[data-cfg-ar-close]')) { closeModal(); return; }
      // Click on the dimmed backdrop (not the box) closes too
      if (modal && !modal.hidden && e.target === modal) closeModal();
    });

    document.addEventListener('keyup', function (e) {
      if (e.key === 'Escape') closeModal();
    });

    // Arrived via a scanned QR? Surface the one-tap launch banner.
    if (banner && (isIOS || isAndroid) &&
        new URLSearchParams(window.location.search).get('room') === '1') {
      banner.hidden = false;
      // Lift Shopify's chat launcher clear of the banner (same pattern as
      // the sticky Add to Basket bar).
      document.body.classList.add('cfg-ar-banner-open');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
